export default __webpack_public_path__ + "images/0x9560e827af36c94d2ac33a39bce1fe78631088db.png";